import React, { useRef } from "react";
import { useDisableScroll, useFocusTrap } from "../../shared/hooks";
import { useBlurAnimation, useDrawerAnimation } from "../../shared/animation";
import * as S from "./styles";
export var SideDrawerItem = function SideDrawerItem(_ref) {
  var e = _ref.active,
      t = _ref.label,
      a = _ref.onClickHandler,
      r = _ref.drawerChildren,
      l = _ref.handleClose,
      n = _ref.icon;
  var c = useRef();
  useDisableScroll(e), useFocusTrap(c, e);
  var o = useDrawerAnimation(e),
      s = useBlurAnimation(e);
  return React.createElement(React.Fragment, null, React.createElement(S.MenuButton, {
    active: e,
    onClick: a
  }, t && t, n && React.createElement(S.IconWrapper, null, n)), o(function (e, a) {
    return a && React.createElement(S.Drawer, {
      style: e,
      ref: c
    }, React.createElement(S.DrawerContent, null, React.createElement(S.DrawerHeading, null, t && React.createElement(S.Label, null, t), React.createElement(S.CloseButtonWrapper, {
      onClick: l
    }, React.createElement(S.CloseIcon, null))), React.createElement(S.HR, null), r));
  }), s(function (e, t) {
    return t && React.createElement(S.Backdrop, {
      onClick: l,
      style: e
    });
  }));
};
export default SideDrawerItem;